// extracted by mini-css-extract-plugin
export default {"container":"KebabMenu_container__cE3nE","menu_pic":"KebabMenu_menu_pic__rmWdu"};